export default __webpack_public_path__ + "static/media/callout_aerial.1b922805.svg";